import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseApiTemplateService} from '../../../shared/base-api-template-service.model';
import {Core2Config} from '../../../shared/core2Config';
import { DeliveryShipmentImportContainerModel } from '../../../../../../../models';
import { ApiVisa } from '../../../shared/api-visa.model';

@Injectable({
    providedIn: 'root'
  })
  export class ShipmentImportService extends BaseApiTemplateService<DeliveryShipmentImportContainerModel> {
      // https://api-test.akaun.com/core2/tnt/dm/del/region-comp-branch-location-links

      //todo: del/ or no del/ ?
    readonly url = Core2Config.DOMAIN_TEST_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'del-shipment/import-file-hdrs/backoffice-ep';
  
    constructor(http: HttpClient) {
      super();
      this.apiUrl = Core2Config.DOMAIN_TEST_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'del-shipment/import-file-hdrs/backoffice-ep';
      this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'del-shipment/import-file-hdrs/backoffice-ep';
      this.httpClient = http;
    }
    
    public uploadImportFile(formData: FormData, visa: ApiVisa, add_to_queue?: boolean, start_hub_guid?: string) {
      if (this.endpoint_path && visa.api_domain_url) {
        this.apiUrl = visa.api_domain_url + this.endpoint_path + '?add_to_queue=' + add_to_queue.toString() +'&start_hub_guid='+start_hub_guid.toString();
      }
      const url = this.apiUrl;
      return this.httpClient.post(url, formData, this.getHttpHeader(visa));
    }
  }